// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import FlightWizardController from "./flight_wizard_controller"
application.register("flight-wizard", FlightWizardController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import FormController from "./form_controller"
application.register("form", FormController)

import TastingSessionController from "./tasting_session_controller"
application.register("tasting-session", TastingSessionController)

import WizardStepController from "./wizard_step_controller"
application.register("wizard-step", WizardStepController)

import CopyToClipboardController from "./copy_to_clipboard_controller"
application.register("copy-to-clipboard", CopyToClipboardController)

import PreserveScrollController from "./preserve_scroll_controller"
application.register("preserve-scroll", PreserveScrollController)

import WizardPreviewController from "./wizard_preview_controller"
application.register("wizard-preview", WizardPreviewController)

import ExpandableCardController from "./expandable_card_controller"
application.register("expandable-card", ExpandableCardController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ProfileBannerController from "./profile_banner_controller"
application.register("profile-banner", ProfileBannerController)

import ProfileModalController from "./profile_modal_controller"
application.register("profile-modal", ProfileModalController)

import ProfileTriggerController from "./profile_trigger_controller"
application.register("profile-trigger", ProfileTriggerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import DashboardWidgetController from "./dashboard_widget_controller"
application.register("dashboard-widget", DashboardWidgetController)

import LiveSearchController from "./live_search_controller"
application.register("live-search", LiveSearchController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import HorizontalSliderController from "./horizontal_slider_controller"
application.register("horizontal-slider", HorizontalSliderController)

import DistilleryFilterController from "./distillery_filter_controller"
application.register("distillery-filter", DistilleryFilterController)

import ProfileWizardController from "./profile_wizard_controller"
application.register("profile-wizard", ProfileWizardController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import BartenderChatController from "./bartender_chat_controller"
application.register("bartender-chat", BartenderChatController)

import WizardAiAssistantController from "./wizard_ai_assistant_controller"
application.register("wizard-ai-assistant", WizardAiAssistantController)
